export default __webpack_public_path__ + "static/media/green_option.0a4a9763.svg";